import { render, staticRenderFns } from "./AddSmaOnlinePayment.vue?vue&type=template&id=0b95924a"
import script from "./AddSmaOnlinePayment.vue?vue&type=script&lang=js"
export * from "./AddSmaOnlinePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports